import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import Visualizer from "@/components/Visualizer";
import BeforeAfter from "@/components/BeforeAfter";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import ChatBot from "@/components/ChatBot";
import WhatsAppButton from "@/components/WhatsAppButton";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function HomePage() {
  return (
    <div className="App" data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <Visualizer />
        <BeforeAfter />
        <Contact />
      </main>
      <Footer />
      <ChatBot />
      <WhatsAppButton />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Toaster richColors position="top-center" />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/albertoadimpannello" element={<AdminLogin />} />
        <Route path="/albertoadimpannello/dashboard" element={<AdminDashboard />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
